<template>
  <div class="uk-grid-medium" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <nav id="breadcrumbs" class="mb-3">
          <ul>
            <li>
              <router-link :to="{ name: 'company.dashboard' }">
                <i class="uil-home-alt"></i>
              </router-link>
            </li>
            <li> {{ $t('general.collection_approvements') }}</li>
          </ul>
        </nav>
      </div>

      <div id="collectionSettingsModal" class="uk-modal" uk-modal>
        <div class="uk-modal-dialog bggray">
          <div class="uk-padding-small" uk-grid>
            <h4> {{ $t('general.collections') }}</h4>
          </div>
          <div class="row p-4">
            <div class="col-lg-12">
              <div class="form-group row mb-2">
                <label class="col-md-6 col-form-label" for="website_keywords">
                  {{ $t('general.collection_approval') }}
                  <i aria-expanded="false" class="uil-info-circle" title="" uk-tooltip="title: "></i></label>
                <div class="col-md-6">
                  <label v-if="collection_is_verified != null" class="uk-switch" for="collection-settings-switch">
                    <input id="collection-settings-switch" v-model="collection_is_verified" type="checkbox"
                      @change="handleCollectionVerification" />
                    <div class="uk-switch-slider"></div>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="uk-modal-footer uk-text-right bggray">
            <button class="uk-button uk-button-default small uk-modal-close" type="button">
              <i class="uil-times"></i> {{ $t("general.close") }}
            </button>
          </div>
        </div>
      </div>

      <div class="section-header mb-lg-2 border-0 uk-flex-middle">
        <div class="section-header-left">
          <h2 class="uk-heading-line text-left"><span>{{ this.$t('general.collections') }} </span></h2>
        </div>
        <div class="section-header-right">
          <a class="btn btn-default dropdown-arrow text-white" uk-toggle="target: #collectionSettingsModal" uk-tooltip="">
            {{ $t('general.collection_settings') }}
          </a>
        </div>
      </div>

      <template v-if="errorMessages">
        <div v-for="(error, index) in errorMessages" :key="index" class="uk-alert-danger" uk-alert>
          <a class="uk-alert-close" uk-close></a>
          <p style="color: red">
            <i class="uil-exclamation-triangle"></i> {{ error }}
          </p>
        </div>
      </template>
      <div v-if="successMessage" class="uk-alert-success" uk-alert>
        <a class="uk-alert-close" uk-close></a>
        <p style="color: green">
          <i class="uil-exclamation-triangle"></i> {{ successMessage }}
        </p>
      </div>

      <div class="card">
        <!-- Card header -->
        <div class="card-header actions-toolbar border-0">
          <div class="d-flex justify-content-between align-items-center">
            <div class="row" style="width:100%">
              <div class=" col-md-1  search-icon ">
                <i class="uil-search"></i>
              </div>
              <div class="col-md-11 uk-search uk-search-navbar" style="margin-left:-2rem">
                <input v-model="filter.search" :placeholder="$t('general.search') + ' - ' + $t('general.collection_name')"
                  autofocus="" class="uk-search-input shadow-0 uk-form-small" type="search" />
              </div>
            </div>
            <div class="d-flex">
              <sort-dropdown :sort-options="sortOptions" @sort-selected="sortOrder" />
            </div>
          </div>
        </div>
        <!-- Table -->
        <div class="table-responsive">
          <default-loading v-if="loading"></default-loading>
          <template v-else>
            <table class="table align-items-center">
              <thead>
                <tr>
                  <th scope="col">{{ $t('general.user') }}</th>
                  <th scope="col">{{ $t('general.collection_name') }}</th>
                  <th scope="col">{{ $t('general.verification_status') }}</th>
                  <th scope="col">{{ $t('general.verification_date') }}</th>
                  <th scope="col"></th>
                </tr>
              </thead>

              <tbody class="list">
                <!-- Koleksiyon -->
                <template v-for="(item, index) in formattedCollectionData">
                  <!-- Ana Koleksiyon Satırı -->
                  <tr>
                    <th scope="row">
                      <div class="media align-items-center">
                        <div>
                          <div class="avatar-parent-child" style="width: max-content">
                            <img :src="item.user_image" alt="Image placeholder" class="avatar rounded-circle" />
                            <span :class="item.is_online ? 'bg-success' : 'bg-offline'"
                              class="avatar-child avatar-badge"></span>
                          </div>
                        </div>
                        <div class="media-body ml-4">
                          <a class="name h6 mb-0 text-sm" href="javascript:void(0)">{{ item.user_name }}</a>
                          <small class="d-block font-weight-bold">#{{ item.user_id }}</small>
                        </div>
                      </div>
                    </th>

                    <td>
                      <span class="name h6 mb-0 text-sm">{{ item.text }}</span>
                    </td>

                    <td>
                      <span v-if="item.is_verified === 1" class="badge badge-success">
                        {{ $t('general.verified') }}
                      </span>
                      <span v-else-if="item.is_verified === 0 && item.verified_at !== null" class="badge badge-danger">
                        {{ $t('general.rejected') }}
                      </span>
                      <span v-else class="badge badge-warning">
                        {{ $t('general.pending') }}
                      </span>
                    </td>

                    <td>
                      <span v-if="item.verified_at" class="text-muted">
                        <i class="uil-calendar-alt"></i> {{ item.verified_at }}
                      </span>
                      <span v-else class="text-muted">--</span>
                    </td>

                    <td class="text-right">
                      <div class="d-flex align-items-center justify-content-end">
                        <!-- Onay/Red -->
                        <template v-if="item.is_verified === 1">
                          <span class="text-success"><i class="uil-check-circle"></i> {{ $t('general.approved') }}</span>
                        </template>
                        <template v-else-if="item.is_verified === 0 && item.verified_at !== null">
                          <span class="text-danger"><i class="uil-times-circle"></i> {{ $t('general.rejected') }}</span>
                        </template>
                        <template v-else>
                          <a class="btn btn-icon btn-hover btn-sm btn-circle" :uk-tooltip="$t('general.approve')"
                            @click="approveOrReject(item.id, 1)">
                            <i class="uil-check-circle text-success"></i>
                          </a>
                          <a class="btn btn-icon btn-hover btn-sm btn-circle" :uk-tooltip="$t('general.reject')"
                            @click="approveOrReject(item.id, 0)">
                            <i class="uil-times-circle text-danger"></i>
                          </a>
                        </template>

                        <!-- Accordion toggle -->
                        <button v-if="item.contents && item.contents.length" class="btn btn-sm btn-icon ml-2"
                          @click="toggleAccordion(index)">
                          <i :class="openIndex === index ? 'uil-angle-up' : 'uil-angle-down'"></i>
                        </button>
                      </div>
                    </td>
                  </tr>

                  <!-- Accordion İçerikler -->
                  <template v-if="item.contents && item.contents.length">
                    <transition name="fade">
                      <tr v-show="openIndex === index">
                        <td></td>
                        <td colspan="4" class="bg-light p-3">
                          <div class="font-weight-bold mb-2 text-secondary">{{ $t('general.contents') }}</div>
                          <table class="table table-borderless mb-0">
                            <thead>
                              <tr>
                                <th>{{ $t('general.content_name') }}</th>
                                <th>{{ $t('general.content_file') }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="content in item.contents" :key="content.id" class="border-bottom">
                                <td class="py-1">{{ content.title }}</td>
                                <td class="py-1">
                                  <a :href="content.url" target="_blank" class="btn btn-primary btn-sm">
                                    {{ $t('general.open_file') }}
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </transition>
                  </template>
                </template>

              </tbody>
            </table>

            <pagination :pagination="pagination" class="mt-2 mb-3" @changePage="setPage($event)"></pagination>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/core/services";
import moment from "moment";
import comment_module, {
  MODULE_NAME,
  ITEMS,
  GET_ITEMS,
  ERROR,
  LOADING,
} from "@/core/services/store/comment.module";
import company_module, {
  ONLINE_USERS,
  MODULE_NAME as COMPANY_MODULE,
} from "@/core/services/store/company.module";

import { GET_ITEM_DETAIL_BY_ID, } from "@/core/services/store/REST.module";

import Pagination from "@/assets/components/Pagination";
import SortDropdown from "@/view/components/dropdown/SortDropdown.vue";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
const _COMPANY_MODULE = COMPANY_MODULE;
import axios from "axios";
import { showError, showSuccess } from "@/utils/alertUtils.js";
import EventBus from "@/view/components/event-bus";

export default {
  name: "Collections",
  components: {
    Pagination,
    SortDropdown,
    DefaultLoading
  },
  data() {
    return {
      openIndex: null,
      companyUrl: "api/company/self",
      collectionVerifiedUrl: "api/company/collection-verified/",
      collectionVerifyManagementUrl: "api/collection-verify-management/",
      sharesUrl: "api/shares-management",
      status_id: 1,
      pagination: null,
      activeItem: null,
      successMessage: null,
      errorMessages: [],
      page: 1,
      company: null,
      collection_is_verified: null,
      per_page: 3,
      filter: {
        search: null,
        order: "desc",
        sort: "created_at",
        assignment_id: null,
        content_id: null,
      },
      sortOptions: [
        { key: 'created_at-asc', sort: 'created_at', order: 'asc', label: this.$t("sorting.created_at_asc") },
        { key: 'created_at-desc', sort: 'created_at', order: 'desc', label: this.$t("sorting.created_at_desc") },
        { key: 'name-asc', sort: 'name', order: 'asc', label: this.$t("sorting.a_z") + ' - ' + this.$t("general.collection_name") },
        { key: 'name-desc', sort: 'name', order: 'desc', label: this.$t("sorting.z_a") + ' - ' + this.$t("general.collection_name") },
      ],
    };
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(MODULE_NAME, comment_module);
    registerStoreModule(_COMPANY_MODULE, company_module);
  },
  computed: {
    loading() {
      return store.getters[MODULE_NAME + "/" + LOADING];
    },
    onlineUsers() {
      return store.getters[_COMPANY_MODULE + "/" + ONLINE_USERS];
    },
    comments: {
      get() {
        return store.getters[MODULE_NAME + "/" + ITEMS];
      },
      set(value) {
      },
    },
    error: {
      get() {
        return store.getters[MODULE_NAME + "/" + ERROR];
      },
      set(value) {
      },
    },
    formattedCollectionData() {
      let results = [];
      if (this.comments === null || !("data" in this.comments)) return [];
      if (typeof this.comments.data === "undefined") return [];

      this.comments.data.forEach((currentItem) => {
        if (currentItem?.user === undefined) return;

        results.push({
          id: currentItem?.id,
          user_name: `${currentItem?.user?.name} ${currentItem?.user?.surname}`,
          user_image: currentItem?.user?.photo_link,
          is_online: !!this.onlineUsers.find(
            (onlineUser) =>
              onlineUser.user === currentItem?.user?.id && onlineUser.status
          ),
          user_id: currentItem?.user?.id,
          text: currentItem?.name, // Koleksiyon adı
          data_type: "collection",
          is_verified: currentItem?.is_verified,
          verified_at: currentItem?.verified_at
            ? moment(currentItem.verified_at).format("DD/MM/YYYY HH:mm")
            : null,

          contents: Array.isArray(currentItem?.contents)
            ? currentItem.contents.map((c) => ({
              id: c.id,
              title: c.title,
              description: c.description,
              cover_photo: c.cover_photo_link,
              file_category: c.file_category?.name ?? "Bilinmiyor",
              content_type: c.content_type ?? null,
              url: c.url || c.file_link

            }))
            : [],
        });
      });

      return results;
    }

  },
  methods: {
    toggleAccordion(index) {
      this.openIndex = this.openIndex === index ? null : index;
    },
    getCollectionVerifyData() {
      this.$store.dispatch(MODULE_NAME + "/" + GET_ITEMS, {
        url: this.collectionVerifyManagementUrl,
        filters: {
          search: this.filter.search,
          page: this.page,
          per_page: this.per_page,
          sort: this.filter.sort,
          order: this.filter.order,
          assignment_id: this.filter.assignment_id,
          content_id: this.filter.content_id,
          status_id: this.status_id,
          with_user: true,
        },
      }).then((response) => {
        this.pagination = response.meta;
      });
    },

    async approveOrReject(id, is_verified) {
      const requestData = {
        is_verified: is_verified === 1 ? true : false
      };

      try {
        const response = await axios.put(this.collectionVerifyManagementUrl + id, requestData);
        if (response.data && response.data.status) {
          showSuccess(this.$t('general.successfully_updated'));
          this.getCollectionVerifyData();
        } else {
          showError(this.$t('general.error_occurred'));
        }
      } catch (error) {
        console.error('Collection verification error:', error);
        showError(this.$t('general.error_occurred'));
      } finally {
        await this.getUnProcessedCollectionCount();
      }
    },

    async getUnProcessedCollectionCount() {
      const { data } = await axios.get(`api/collection-verify-management`, {
        params: {
          count: true
        }
      })

      EventBus.$emit("collectionContentCount", data ?? 0);
    },

    getCompany() {
      this.$store
        .dispatch(GET_ITEM_DETAIL_BY_ID, {
          url: this.companyUrl,
          acceptPromise: true,
        })
        .then((result) => {
          if (result.status) {
            const collectionSetting = result.data.settings?.find(setting => setting.key === 'collection_is_verified');
            this.collection_is_verified = collectionSetting ? (collectionSetting.value === 1 || collectionSetting.value === true) : false;
            this.company = result.data;
          }
        });
    },

    handleCollectionVerification() {
      const requestData = {
        collection_is_verified: this.collection_is_verified
      };

      axios.post(this.collectionVerifiedUrl + this.company.id, requestData).then((response) => {
        if (response.data && response.data.status) {
          showSuccess(this.$t('general.successfully_updated'));
        } else {
          showError(this.$t('general.error_occurred'));
        }
      }).catch((error) => {
        console.error('Collection verification error:', error);
        showError(this.$t('general.error_occurred'));
      });
    },

    sortOrder({ sort, order }) {
      this.page = 1;
      this.filter.sort = sort;
      this.filter.order = order;
      this.getCollectionVerifyData();
    },

    setPage(page) {
      this.page = page;
      this.getCollectionVerifyData();
    },

    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
  },
  mounted() {
    this.getCompany();
    this.getCollectionVerifyData();
  },
  beforeDestroy() {
    const collectionSettingsModal = UIkit.modal("#collectionSettingsModal");
    if (collectionSettingsModal) collectionSettingsModal.$destroy(true);
  },
  watch: {
    "filter.search": function (val) {
      this.page = 1;
      this.debouncedFilterSearch();
    },
    successMessage: function (val) {
      this.debouncedResetValues();
    },
    errorMessages: function (val) {
      this.debouncedResetValues();
    },
  },
  created: function () {
    this.debouncedFilterSearch = _.debounce(this.getCollectionVerifyData, 500);
    this.debouncedResetValues = _.debounce(this.resetMessages, 2000);
  },
};
</script>
<style scoped>
input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
